import { BookOutlined }             from '@ant-design/icons';
import { FileTextOutlined }         from '@ant-design/icons';
import { InteractionOutlined }      from '@ant-design/icons';
import { CrownOutlined }            from '@ant-design/icons';
import { HomeOutlined }             from '@ant-design/icons';
import { TeamOutlined }             from '@ant-design/icons';
import { UserOutlined }             from '@ant-design/icons';
import AdminUserModel               from './models/services/admin/AdminUserModel';
import SubscriptionModel            from './models/services/account/SubscriptionModel';
import InvoiceModel                 from './models/services/account/InvoiceModel';
import AccountModel                 from './models/services/account/AccountModel';
import UserModel                    from './models/services/account/UserModel';
import EventModel                   from './models/services/audit/EventModel';
import { GlobalOutlined }           from '@ant-design/icons';
import MenuModel                    from '@models/admin/MenuModel';
import { MenuOutlined }             from '@ant-design/icons';
import SitePageModel                from '@models/admin/SitePageModel';
import { PicLeftOutlined }          from '@ant-design/icons';
import { MailOutlined }             from '@ant-design/icons';
import { ProjectOutlined }          from '@ant-design/icons';
import ProjectTemplateModel         from '@models/map/ProjectTemplateModel';
import ClientRequestModel           from '@models/account/ClientRequestModel';
import Icon                         from '@widesk-ui/components/Icon';
import ClientRequestNavigationLabel from '@/components/clientRequest/ClientRequestNavigationLabel';

export default [
	{
		label: 'Accueil',
		link: '/',
		icon: <HomeOutlined />,
	},
	{
		label: AccountModel.localize('plural'),
		link: AccountModel.pagePath('list'),
		icon: <TeamOutlined />,
	},
	{
		label: UserModel.localize('plural'),
		link: UserModel.pagePath('list'),
		icon: <UserOutlined />,
	},
	{
		label: AdminUserModel.localize('plural'),
		link: AdminUserModel.pagePath('list'),
		icon: <CrownOutlined />,
	},
	{
		label: SubscriptionModel.localize('plural'),
		link: SubscriptionModel.pagePath('list'),
		icon: <BookOutlined />,
	},
	{
		label: InvoiceModel.localize('plural'),
		link: InvoiceModel.pagePath('list'),
		icon: <FileTextOutlined />,
	},
	{
		label: EventModel.localize('plural'),
		link: EventModel.pagePath('list'),
		icon: <InteractionOutlined />,
	},
	{
		label: ProjectTemplateModel.localize('plural'),
		link: ProjectTemplateModel.pagePath('list'),
		icon: <ProjectOutlined />,
	},
	{
		label: <ClientRequestNavigationLabel />,
		link: ClientRequestModel.pagePath('list'),
		icon: <Icon name="support-headset" />,
	},
	{
		key: 'website',
		label: 'Site public',
		icon: <GlobalOutlined />,
		children: [
			{
				key: '/menus',
				label: MenuModel.localize('plural'),
				link: MenuModel.pagePath('list'),
				icon: <MenuOutlined />,
			},
			{
				key: '/site_pages',
				label: SitePageModel.localize('plural'),
				link: SitePageModel.pagePath('list'),
				icon: <PicLeftOutlined />,
			},
		],
	},
	{
		label: 'Mails',
		link: '/mails/account/',
		icon: <MailOutlined />,
	},
];

export const navigationSettings = [];
